module.exports = __webpack_public_path__ + "media/old_images/icon-filter-4f2f9ccc.svg";